/*
 * Copyright French Prime minister Office/SGMAP/DINSIC/Vitam Program (2019-2022)
 * and the signatories of the "VITAM - Accord du Contributeur" agreement.
 *
 * contact@programmevitam.fr
 *
 * This software is a computer program whose purpose is to implement
 * implement a digital archiving front-office system for the secure and
 * efficient high volumetry VITAM solution.
 *
 * This software is governed by the CeCILL-C license under French law and
 * abiding by the rules of distribution of free software.  You can  use,
 * modify and/ or redistribute the software under the terms of the CeCILL-C
 * license as circulated by CEA, CNRS and INRIA at the following URL
 * "http://www.cecill.info".
 *
 * As a counterpart to the access to the source code and  rights to copy,
 * modify and redistribute granted by the license, users are provided only
 * with a limited warranty  and the software's author,  the holder of the
 * economic rights,  and the successive licensors  have only  limited
 * liability.
 *
 * In this respect, the user's attention is drawn to the risks associated
 * with loading,  using,  modifying and/or developing or reproducing the
 * software by the user in light of its specific status of free software,
 * that may mean  that it is complicated to manipulate,  and  that  also
 * therefore means  that it is reserved for developers  and  experienced
 * professionals having in-depth computer knowledge. Users are therefore
 * encouraged to load and test the software's suitability as regards their
 * requirements in conditions enabling the security of their systems and/or
 * data to be ensured and,  more generally, to use and operate it in the
 * same conditions as regards security.
 *
 * The fact that you are presently reading this means that you have had
 * knowledge of the CeCILL-C license and that you accept its terms.
 */
import { Injectable, inject } from '@angular/core';

import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { GlobalEventService } from './global-event.service';
import { WINDOW_LOCATION } from './injection-tokens';
import { StartupService } from './startup.service';

const APPLICATION_TRANSLATE_PATH = 'APPLICATION';

@Injectable({
  providedIn: 'root',
})
export class AppGuard {
  private readonly authService = inject(AuthService);
  private readonly startupService = inject(StartupService);
  private readonly titleService = inject(Title);
  private readonly globalEventService = inject(GlobalEventService);
  private readonly location = inject(WINDOW_LOCATION);
  private readonly translateService = inject(TranslateService);

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!next.data.hasOwnProperty('appId')) {
      console.error('AppGuard Error: Missing "appId" property in route declaration. Please add the property to the route\'s data');
      return false;
    }
    const appId = next.data['appId'];
    const foundAppProfile = this.authService.user.profileGroup.profiles.find((profile) => profile.applicationName === appId);
    if (!foundAppProfile) {
      this.location.href = this.startupService.getPortalUrl();
      return false;
    }

    this.startupService.CURRENT_APP_ID = appId;
    if (this.translateService.getCurrentLang()) {
      this.titleService.setTitle(this.translateService.instant(`${APPLICATION_TRANSLATE_PATH}.${appId}.NAME`));
    }
    this.translateService.onLangChange.subscribe((_: LangChangeEvent) => {
      this.titleService.setTitle(this.translateService.instant(APPLICATION_TRANSLATE_PATH + '.' + appId + '.NAME'));
    });

    // set user default tenant Identifier whenever we switch pages
    this.startupService.setTenantIdentifier();
    // emit page change event
    this.globalEventService.pageEvent.next(appId);

    return true;
  }
}
